import ServerElement from "./ServerElement";
import { Box } from "@mui/material";
import { LogoBar } from "../../LogoBar";
import useServerElements from "../hooks/useServerElements";
import { IServerElement } from "../types/serverElements";

/**
 * Fetches HTML server elements based on the provided `pageId` url parameter.
 * Renders the elements grouped by their `group_name`.
 * Utilizes the `ServerElement` component to render individual segments.
**/
const DinamicServerPage = ({ }) => {
  const { elementByGroupName } = useServerElements({});

  const renderListOfElements = (arrayOfElements:IServerElement[]) => {
    return arrayOfElements.map((serverElement) => {
      const flexBasisValue = (serverElement["blockWidth"]) ? serverElement["blockWidth"]+"px": "100%";
      return (
        <Box key={serverElement.id} style={{flex: 1, textAlign: "center", flexBasis: flexBasisValue}}>
          <ServerElement htmlElement={serverElement} />
        </Box>
      )
    })
  }

  const renderGroups = () => {
    const groups = [];
    for (let key in elementByGroupName) {
      groups.push(
        <Box key={key} style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 4 }}>
          {renderListOfElements(elementByGroupName[key])}
        </Box>
      )
    }
    return groups;
  }

  return (
    <div>
      { 
        Object.values(elementByGroupName).length ? (
          renderGroups()
        ) : (
          <LogoBar />
        )
      }
    </div>
  )
}

export default DinamicServerPage;
